import { startLenis, stopLenis } from './constants';

const header = {
    name: 'header',
    logoIsDark: false,
    elements: {},

    init() {
        this.cacheDOM();
        this.bindEvents();
        this.onScroll();
        this.setupMobileMenu();
        this.handleInitialHash();
        this.setActiveLink(); // Initialize active states for page links
    },

    cacheDOM() {
        this.elements = {
            header: document.querySelector('.header'),
            logo: document.querySelector('.header-logo'),
            mobileMenu: document.querySelector('#mobile-menu'),
            burger: document.querySelector('#header-burger button'),
            links: document.querySelectorAll('.header a[href^="#"], .header a[href^="/#"], #mobile-menu a[href^="#"], #mobile-menu a[href^="/#"]'),
            allLinks: document.querySelectorAll('.header a, #mobile-menu a'),
            sections: document.querySelectorAll('section')
        };
    },

    bindEvents() {
        window.addEventListener('scroll', () => this.onScroll());
        this.elements.links.forEach(link => link.addEventListener('click', (event) => this.scrollTo(event, link)));
    },

    onScroll() {
        for (const section of this.elements.sections) {
            const rect = section.getBoundingClientRect();
            if (rect.top <= 100 && rect.bottom > 100) {
                this.updateHeader(section);
                this.setActiveLink(section.id);
                break;
            }
        }
    },

    updateHeader(section) {
        const { header, logo } = this.elements;
        header.classList.remove('neutral', 'inverted');
        logo.classList.remove('dark');

        let headerClass = '';
        this.logoIsDark = false;

        if (section.classList.contains('hero')) {
            headerClass = 'neutral';
            this.logoIsDark = true;
        } else if (section.classList.contains('hero-simple')) {
            headerClass = 'neutral';
            this.logoIsDark = false;
        } else if (section.classList.contains('white') || section.classList.contains('frost')) {
            headerClass = 'inverted';
            this.logoIsDark = true;
        }

        if (headerClass) {
            header.classList.add(headerClass);
        }
        if (this.logoIsDark) {
            logo.classList.add('dark');
        }
    },

    setActiveLink(sectionId = null) {
        const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

        this.elements.allLinks.forEach(link => {
            const href = link.getAttribute('href');

            // Check if it's an anchor link
            if (href && (href.startsWith('#') || href.startsWith('/#'))) {
                const linkHref = href.replace(/^#|^\/#/, '');
                link.classList.toggle('active', sectionId && linkHref === sectionId);
            }
            // Check if it's a page link
            else if (href) {
                // Extract path from href (remove domain if present and hash)
                let linkPath = href.split('#')[0];

                // If it's a full URL, extract just the pathname
                try {
                    const url = new URL(href, window.location.origin);
                    linkPath = url.pathname;
                } catch {
                    // If parsing fails, it's already a relative path
                }

                // Normalize paths by removing trailing slashes (except for root)
                linkPath = linkPath.replace(/\/$/, '') || '/';

                link.classList.toggle('active', linkPath === currentPath);
            }
        });
    },

    setupMobileMenu() {
        const { burger, mobileMenu, logo, header } = this.elements;

        burger.addEventListener('click', () => {
            const isExpanded = burger.getAttribute('aria-expanded') === 'true';
            burger.setAttribute('aria-expanded', (!isExpanded).toString());
            mobileMenu.setAttribute('aria-hidden', isExpanded.toString());

            if (!isExpanded) {
                this.logoIsDark = logo.classList.contains('dark');
                logo.classList.remove('dark');
                stopLenis();
                document.body.style.overflow = 'hidden';
                header.classList.add('opened');
            } else {
                startLenis();
                document.body.style.overflow = '';
                if (this.logoIsDark) {
                    logo.classList.add('dark');
                }
                header.classList.remove('opened');
            }
        });
    },

    scrollTo(event, link) {
        event.preventDefault();
        const targetId = link.getAttribute('href').replace(/^#|^\/#/, '');
        const target = document.getElementById(targetId);

        if (target) {
            const offset = target.getBoundingClientRect().top + window.pageYOffset;

            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });

            if (link.closest('#mobile-menu')) {
                const { burger } = this.elements;
                if (burger.getAttribute('aria-expanded') === 'true') {
                    burger.click();
                }
            }
        } else {
            window.location.href = '/#' + targetId;
        }
    },

    handleInitialHash() {
        window.addEventListener('load', () => {
            const hash = window.location.hash.replace('#', '');
            if (hash) {
                const target = document.getElementById(hash);
                if (target) {
                    setTimeout(() => {
                        const offset = target.getBoundingClientRect().top + window.pageYOffset;
                        window.scrollTo({
                            top: offset,
                            behavior: 'smooth'
                        });
                    }, 100);
                }
            }
        });
    }
};

export default header;